export default __webpack_public_path__ + "static/media/arrow-back-in-circle.a87e44b9.svg";